import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "compTree" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Add component", -1)
const _hoisted_4 = {
  class: "absoluteMenu compAddMenu",
  ref: "compAddMenu"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "content_paste", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Paste ")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "divider"
}
const _hoisted_9 = { class: "material-icons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_component_list = _resolveComponent("component-list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_component_list, {
      class: "actualTree",
      root: "",
      components: _ctx.componentTree,
      modelValue: _ctx.selectedComponent,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateSelection(val)),
      onCopy: _cache[2] || (_cache[2] = $event => (_ctx.copiedComponent = $event)),
      onDeleted: _ctx.checkDelete,
      onAddChild: _ctx.addChildToTreeElem
    }, null, 8, ["components", "modelValue", "onDeleted", "onAddChild"]),
    _createVNode("div", {
      class: "btn",
      onClick: _cache[4] || (_cache[4] = ev => _ctx.showCompAddMenu(ev))
    }, [
      _hoisted_2,
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_ctx.copiedComponent)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", {
                class: "entry",
                onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.pasteComponent()), ["stop"]))
              }, [
                _hoisted_5,
                _hoisted_6
              ]),
              _hoisted_7
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.componentNames, (key, index) => {
          return (_openBlock(), _createBlock("div", { key: index }, [
            (index != 0)
              ? (_openBlock(), _createBlock("div", _hoisted_8))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: "entry",
              onClick: _withModifiers($event => (_ctx.addNewCompoenent(key)), ["stop"])
            }, [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.componentInfo[key].icon), 1),
              _createTextVNode(" " + _toDisplayString(key), 1 /* TEXT */)
            ], 8, ["onClick"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512)
    ])
  ]))
}